import instance from "../utils/network";
import { SellerHasTournamentTicketListResponse } from "./tournament-ticket";

export interface PointDistributionDetail {
  position: number;
  memberId: number;
  entryPoints: number; // 참가비로 쓴 포인트
  resultPoints: number; // 받은 포인트
  totalPoints: number; // entryPoints - resultPoints 이거 매장 입장에서는 반대?
  nickname: string;
}

export interface SeedDistributionDetail {
  position: number;
  memberId: number;
  entrySeeds: number; // 참가비로 쓴 시드
  resultSeeds: number; // 받은 시드
  resultCarrots?: number; // 받은 캐럿(CR)
  totalSeeds: number; // entrySeeds - resultSeeds 이거 매장 입장에서는 반대?
  resultSubPrizes: number; // 받은 부상
  subPrizeId: number;
  nickname: string;
}

export interface PaymentPrizeRequest {
  memberId: number;
  tournamentId: number;
  finalPosition: number;
  seedAmount: number;
  carrotAmount?: number; // 캐럿(CR) 시상
  pointAmount?: number;
  prizeType: string | null;
}

export interface TournamentPointPaidResponse {
  prizeList: TournamentPointPaidDto[];
}
export interface TournamentPointPaidDto {
  rank: number; // 순위
  seedPrize: number; // 실질적 지급되는 시드 값 (추가시상 값 포함)
  carrotPrize?: number; // 실질적 지급되는 캐럿(CR) 값
  pointPrize?: number; // 실질적 지급되는 포인트 값
  nickname: string | null;
  memberId: number | null;
  payMent: boolean; // 지급 여부
  totalPrize: number; // 전체 프라이즈 합 (시드 + 포인트 + 부상)
  subPrize: SellerHasTournamentTicketListResponse | null; // 부상
  subPrizeCount: number; // 부상 갯수
}

export function getPointAndSeedDistributionDetail(
  tournamentId: number
): Promise<{
  seedDistributionDetails: SeedDistributionDetail[];
  distributionDetails: PointDistributionDetail[];
}> {
  return instance.get(`/seller/tournament/prize/distribution/${tournamentId}`);
}

export function getTournamentPrizeList(
  tournamentId: number
): Promise<TournamentPointPaidResponse> {
  return instance.get(`/seller/tournament/prize/list/${tournamentId}`);
}

export function resetUserPrizeSeed(request: PaymentPrizeRequest) {
  return instance.delete(`/seller/tournament/prize/seed/single-rank`, {
    data: request,
  });
}

export function resetAllPrizeSeed(tournamentId: number) {
  return instance.delete(`/seller/tournament/prize/seed/rank/${tournamentId}`);
}

export function paymentAllPrizeSeed(request: PaymentPrizeRequest[]) {
  return instance.post(`/seller/tournament/prize/seed/rank`, request);
}

export function paymentUserPrizeSeed(request: PaymentPrizeRequest) {
  return instance.post(`/seller/tournament/prize/seed/single-rank`, request);
}
